// src/components/CoupleInfo.js
import React, { useState } from 'react';
import { calculateDaysTogether, formatDate } from '../utils/dateUtils';
import StartDateEdit from './StartDateEdit';
import '../styles/CoupleInfo.css';

const CoupleInfo = ({ coupleInfo, currentUser, onCoupleInfoUpdate, onLeaveCouple }) => {
    const [isEditingStartDate, setIsEditingStartDate] = useState(false);

    if (!coupleInfo) return null;

    const daysTogetherCount = calculateDaysTogether(coupleInfo.startedAt);
    const partner = coupleInfo.members.find(member => member.memberId !== currentUser.id);

    const handleStartDateUpdate = (updatedCoupleInfo) => {
        onCoupleInfoUpdate(updatedCoupleInfo);
        setIsEditingStartDate(false);
    };

    return (
        <section className="couple-info-section">
            <div className="couple-info-card">
                <h3>💑 커플 정보</h3>
                
                <div className="couple-details">
                    <div className="couple-basic-info">
                        <p><strong>커플 ID:</strong> {coupleInfo.coupleId}</p>
                        <div className="start-date-section">
                            <p>
                                <strong>커플 시작일:</strong> {formatDate(coupleInfo.startedAt)}
                                <button 
                                    className="edit-start-date-btn"
                                    onClick={() => setIsEditingStartDate(true)}
                                    title="시작일 수정"
                                >
                                    ✏️
                                </button>
                            </p>
                        </div>
                        <div className="days-together">
                            <span className="days-label">함께한 지</span>
                            <span className="days-count">D+{daysTogetherCount}</span>
                        </div>
                    </div>
                    
                    {partner && (
                        <div className="partner-info">
                            <h4>💕 상대방 정보</h4>
                            <div className="partner-card">
                                <div className="partner-avatar">
                                    {partner.profileImage ? (
                                        <img src={partner.profileImage} alt="상대방 프로필" />
                                    ) : (
                                        <div className="default-avatar">👤</div>
                                    )}
                                </div>
                                <div className="partner-details">
                                    <p className="partner-nickname">{partner.nickname}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="couple-leave-footer">
                    <button className="couple-leave-btn" onClick={onLeaveCouple}>
                        커플 탈퇴
                    </button>
                </div>
            </div>

            {/* 시작일 수정 모달 */}
            {isEditingStartDate && (
                <StartDateEdit
                    currentStartDate={coupleInfo.startedAt}
                    onClose={() => setIsEditingStartDate(false)}
                    onSuccess={handleStartDateUpdate}
                />
            )}
        </section>
    );
};

export default CoupleInfo;
